import Button from '../Button'
import styles from './styles.module.scss'
import { ComponentConsumerProps, Field, Image, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import React from 'react';

type PolicyCard = {
  description: string
  link: string,
  linkTitle: string,
  title: string,
  icon?: {
    alt: string,
    src: string,
    height: string,
    width: string,
    title: string
  }
}

type RelatedPoliciesProps = ComponentConsumerProps & {
  fields: {
    fallback: boolean
    policies?: PolicyCard[]
    title: string
  }
}

const RelatedPolicies: React.FC<RelatedPoliciesProps> = ({
  fields: { policies, title, fallback }
}) => {

  if (fallback) {
    console.log("[RelatedPolicies] - Using fallback datasource");
  }


  if (policies === undefined || policies.length < 1) {
    console.log("[RelatedPolicies] - No Policies found.")
  }
  return (
    <div className={styles.relatedPoliciesWrapper}>
      <div className={styles.relatedPoliciesContent}>
        <div className={styles.relatedPoliciesTitle}>
          <div className="h2">{title}</div>
        </div>
        <div>
          <div className={styles.relatedPoliciesList}>
            {policies?.map((policy, i) => (
              <div className={styles.relatedPoliciesItem} key={i}>
                <div className={styles.relatedPoliciesItemTitle}>
                  <div className='h3'>{policy.title}</div>
                </div>
                <div className={styles.relatedPoliciesNavWrapper}>
                  <div className={styles.relatedPoliciesItemDescription}>
                    {policy?.icon?.src ? (
                      <img
                        src={policy.icon.src} 
                        alt={policy.icon.alt} 
                        width={policy.icon.width}
                        height={policy.icon.height}
                      />
                    ) : (
                      <Text field={{ value: policy.description }} />
                    )}
                  </div>
                  <div className={styles.relatedPoliciesItemLink}>
                    <Button href={policy.link} secondary>
                      <Text field={{ value: policy.linkTitle }} />
                    </Button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}


export default withSitecoreContext()(RelatedPolicies)
